<div class="graphic-wrapper">
  <div>
    <section
      id="package-container"
      class="package-container">
      <div
        class="package-element"
        [style]="boxStyle()">
        <div class="face front"></div>
        <div class="face back"></div>
        <div class="face right"></div>
        <div class="face left"></div>
        <div class="face top"><div class="top-parcel-line"></div></div>
        <div class="face bottom"></div>
      </div>
    </section>
  </div>
</div>
